/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgerbalance2Inputs */

const zh_adminsubs_ledgerbalance2 = /** @type {(inputs: Adminsubs_Ledgerbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`余额`)
};

const en_adminsubs_ledgerbalance2 = /** @type {(inputs: Adminsubs_Ledgerbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

const es_adminsubs_ledgerbalance2 = /** @type {(inputs: Adminsubs_Ledgerbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo`)
};

/**
* | output |
* | --- |
* | "Balance" |
*
* @param {Adminsubs_Ledgerbalance2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgerbalance2 = /** @type {((inputs?: Adminsubs_Ledgerbalance2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgerbalance2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgerbalance2(inputs)
	if (locale === "en") return en_adminsubs_ledgerbalance2(inputs)
	return es_adminsubs_ledgerbalance2(inputs)
});
export { adminsubs_ledgerbalance2 as "adminSubs_ledgerBalance" }